const options = {
  5: "bg-amber-100/5",
  10: "bg-amber-100/10",
  25: "bg-amber-100/25",
  50: "bg-amber-100/50",
  75: "bg-amber-100/75",
  90: "bg-amber-100/90",
  100: "bg-amber-100",
};

const from = {
  5: "from-amber-100/5",
  10: "from-amber-100/10",
  25: "from-amber-100/25",
  50: "from-amber-100/50",
  75: "from-amber-100/75",
  90: "from-amber-100/90",
  100: "from-amber-100",
};

export default function getBackgroundAmber100(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
